import { z } from 'zod'
import { useApi } from '../../utils/useApi'

// ============================================
// GET /get_all_sites_and_devices
// ============================================

const AccessControlSiteSchema = z.object({
    site: z.string(),
    pd_lot_id: z.string(),
    pin_timeout: z.string(),
    live: z.boolean()
})

const AccessControlDeviceSchema = z.object({
    device: z.string(),
    device_id: z.string(),
    device_state: z.string(),
    device_type: z.string(),
    site: z.string(),
    site_id: z.string(),
    lp_access_station_mapping: z.string().nullable().optional(),
    lp_access_staleness_time_s: z.number().int().nullable().optional(),
    lp_access_deduplication_time_s: z.number().int().nullable().optional()
})

const AccessControlGetAllSitesAndDevicesResponseSchema = z.object({
    sites: z.array(AccessControlSiteSchema),
    devices: z.array(AccessControlDeviceSchema)
})

export type AccessControlSite = z.infer<typeof AccessControlSiteSchema>
export type AccessControlDevice = z.infer<typeof AccessControlDeviceSchema>
export type AccessControlGetAllSitesAndDevicesResponse = z.infer<
    typeof AccessControlGetAllSitesAndDevicesResponseSchema
>

export { AccessControlGetAllSitesAndDevicesResponseSchema }

export const useGetAllSitesAndDevicesQuery = () =>
    useApi(
        '/access-control/get_all_sites_and_devices',
        {},
        AccessControlGetAllSitesAndDevicesResponseSchema,
        {
            queryKey: ['accessControlSitesAndDevices'],
            retry: false,
            staleTime: 30 * 60 * 1000
        },
        'GET'
    )
